import { Component } from '@angular/core';
import { loadStripe } from '@stripe/stripe-js';

@Component({
  selector: 'app-pricing',
  // standalone: true,
  // imports: [],
  templateUrl: './pricing.component.html',
  styleUrl: './pricing.component.scss'
})
export class PricingComponent {
  selectedDiv: string = 'marketing';


  async onClickMe(){
    console.log('the selected input is:' );
  

try {
    debugger;
    const pubkey='pk_test_51LCuh5HYJqTHCNGcAjUNkULSvloxzNbLf9jcnHQblExzB7zEFwFFBISVll2OHIepMuuyjyTsgH0XY5vTNwwnucMB00ZKdAowT3';
    //const response = await loadStripe('pk_test_51LCuh5HYJqTHCNGcAjUNkULSvloxzNbLf9jcnHQblExzB7zEFwFFBISVll2OHIepMuuyjyTsgH0XY5vTNwwnucMB00ZKdAowT3');
    const response = await loadStripe(pubkey);
    debugger;
    const data = response;
    console.log(data);
    await response.redirectToCheckout
    ({
        lineItems:[
            {
            price:'price_1LD6ADHYJqTHCNGc2gR7RsjR',
            quantity:1,
                
        }
        ],
        mode:'subscription',
        successUrl:'http://localhost:4200/pages/profile?session_id={CHECKOUT_SESSION_ID}',
        
        cancelUrl:'http://localhost:4200'
    })
} catch (error) {
    console.log(error);
}
}


  selectDiv(divName: string) {
    this.selectedDiv = divName;
  }

}
